





import { Component, Vue } from 'nuxt-property-decorator'

interface ParamsType {
  email: string | null | (string | null)[]
  signup: boolean
  referral_code?: string | null | (string | null)[]
}

@Component({
  name: 'Signup',
  layout: 'clean',
  auth: false,
})
export default class extends Vue {
  error: boolean = false
  errorDescription: string | null = ''

  mounted() {
    this.$loadingScreen.show = false
    this.$auth.$storage.setUniversal('redirect', '/onboarding')
    const params: ParamsType = { email: this.$route.query.email, signup: true }
    const urlReferralCode = this.$route.query.referral_code
    const localStorageReferralCode = localStorage.getItem('referral_code')
    if (urlReferralCode)
      params.referral_code = urlReferralCode
    else if(localStorageReferralCode)
      params.referral_code = localStorageReferralCode
    localStorage.removeItem('referral_code')
    this.$auth.loginWith('auth0', { params })
  }
}
